import React, { useState, useEffect } from 'react';

const useDeviceDetect = () => {
    const [isMobile, setIsMobile] = useState(false);

    const checkIsMobile = () => {
        const userAgent = navigator.userAgent || window.opera;
        if (
            /android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i.test(
                userAgent
            )
        ) {
            setIsMobile(true);
        } else {
            setIsMobile(window.innerWidth <= 1024);
        }
    };

    useEffect(() => {
        checkIsMobile();
        const handleResize = () => checkIsMobile();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return { isMobile: isMobile || window.innerWidth <= 786 };
};

export default useDeviceDetect;
